// test7
(7 && 0);
